import {PageTitle, mergeSxs, BackToLink, Flag} from '@hconnect/uikit/src/lib2'
import {Box, Stack} from '@mui/material'
import {memo, ReactNode} from 'react'
import {useNavigate} from 'react-router'

type StatusPageHeaderProps = {
  title?: string
  countryCode?: string
  backButtonProps?: {
    targetName: string
    target: string
  }
  onGoBackClick: (route: string) => void
  // true on the legacy blue surface (hproduce); false (default) on the Suite surface
  inverted?: boolean
  filterComponent?: ReactNode
  actionButtons?: ReactNode
}

export const PageHeader = memo<StatusPageHeaderProps>(
  ({
    title,
    countryCode,
    filterComponent,
    backButtonProps,
    actionButtons,
    onGoBackClick,
    inverted = false
  }) => {
    const navigate = useNavigate()

    return (
      <>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          justifyContent={'space-between'}
          flexWrap="wrap"
          mb={3}
          gap={1}
          sx={mergeSxs((theme) => ({
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
              mb: theme.spacing(2)
            }
          }))}
        >
          <Stack justifyContent="space-between" mr="auto">
            {backButtonProps && (
                <BackToLink
                  navigate={(route) => {
                    onGoBackClick(route)
                    void navigate(route)
                  }}
                  targetName={backButtonProps.targetName}
                  target={backButtonProps.target}
                />
            )}
            <PageTitle
              mx={3}
              mb={!backButtonProps ? 2 : 0}
              sx={{display: 'inline-flex', alignItems: 'center'}}
              data-test-id="page-title"
            >
              {countryCode && (
                <Flag
                  countryCode={countryCode}
                  alt={countryCode}
                  sx={{
                    verticalAlign: 'text-bottom',
                    mr: 1
                  }}
                />
              )}
              {title || countryCode}
            </PageTitle>
          </Stack>
          {(filterComponent || actionButtons) && (
            <Box
              display="flex"
              flexDirection={{xs: 'column', sm: 'row'}}
              justifyContent="space-between"
              gap={1}
              m={{xs: 2, sm: 0}}
            >
              {filterComponent}
              {actionButtons}
            </Box>
          )}
        </Stack>
      </>
    )
  }
)
